import { Link } from "@inertiajs/react"
import type { ComponentPropsWithoutRef } from "react"

import { Icon } from "@/components/icon"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import type { NavItem } from "@/types"

// Footer nav items mix two kinds of destination:
//   - Internal Inertia routes (Organization, Settings) navigate in-place
//     via Inertia's <Link> so the SPA stays in one tab and the shared
//     org context survives the transition.
//   - External routes (Database Admin → Motor::Admin, a mounted Rails
//     engine) are NOT Inertia pages. An Inertia <Link> would fire an
//     X-Inertia XHR expecting a JSON page that never comes, so it fails
//     to load. Those use a plain anchor opened in a new tab.
export function NavFooter({
  items,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof SidebarGroup> & {
  items: NavItem[]
}) {
  return (
    <SidebarGroup
      {...props}
      className={`group-data-[collapsible=icon]:p-0 ${className ?? ""}`}
    >
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                asChild
                className="text-neutral-600 hover:text-neutral-800 dark:text-neutral-300 dark:hover:text-neutral-100"
              >
                {item.external ? (
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    {item.icon && (
                      <Icon iconNode={item.icon} className="h-5 w-5" />
                    )}
                    <span>{item.title}</span>
                  </a>
                ) : (
                  <Link href={item.href} prefetch>
                    {item.icon && (
                      <Icon iconNode={item.icon} className="h-5 w-5" />
                    )}
                    <span>{item.title}</span>
                  </Link>
                )}
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
